<template>
  <div>
    <div class="row justify-content-center">

      <div id="map" style="width:100%;height:400px;">

        <button class="btn btn-info bmd-btn-fab bmd-btn-fab-sm" @click="getGeoLocation()" style="position:absolute;top:10px;left:20px;z-index:1000;" >
          <i class="material-icons" style="vertical-align: middle">gps_fixed</i>
        </button>
        <button class="btn btn-info btn-raised active btn-refresh pl-2 pr-3" @click="findMaskFromCurrentMap()" style="border-radius:10px;position:absolute;top:10px;left:50%;transform:translateX(-50%);z-index:1000;">
          <i class="material-icons" style="vertical-align: middle">refresh</i>
          <span>이 지역 마스크 검색</span>
        </button>
        <button class="btn btn-description btn-outline p-1" style="position:absolute;bottom:0px;right:20px;z-index:1000;">
          <i class="material-icons text-info pin-icon">location_on</i>: 많음(100+)
          <i class="material-icons text-success pin-icon">location_on</i>: 보통(30~99)
          <i class="material-icons text-warning pin-icon">location_on</i>: 부족(2~29)
          <i class="material-icons text-muted pin-icon">location_on</i>: 없음(0~1)
        </button>
      </div>

      <div v-if="isLoading" class="text-center pt-5">
        <circle8></circle8>
      </div>

      <div v-else>

        <div class="card card-container pt-0 pb-0 mb-0">
          <div class="btn-group">
            <button class="btn btn-info mb-0" v-bind:class="{'active': order === 0}" @click="changeOrder(0)"> 재고순 </button>
            <button class="btn btn-info mb-0" v-bind:class="{'active': order === 1}" @click="changeOrder(1)"> 입고순 </button>
            <!--          <input type="radio" name="options" id="option3" autocomplete="off" v-bind:class="{'checked': order === 2}" @click="changeOrder(2)"> 거리순-->
          </div>
        </div>
        <div class="card card-container" v-for="(row, index) in maskData" >
          <div class="row">
            <div class="col-9">
              <span class="store-name">{{row.name}}</span>
              <span v-bind:class="['badge-text', 'badge', 'badge-pill', getBadgeStyle(row.remain_stat)]">
              {{getTextString(row.remain_stat)}}
              </span>
              <h6 class="store-address mb-2">{{row.addr}}</h6>
              <p class="store-date card-text text-muted">입고 : {{row.stock_at}}<br/>재고 업데이트 : {{row.created_at}}</p>
            </div>
            <div class="col-3">
              <button v-bind:class="['btn', 'btn-outline', 'active', 'jump-a', getButtonStyle(row.remain_stat)]"
                      @click="moveAndJumpPin(index)">위치보기</button>
              <button v-bind:class="['btn', 'btn-outline', 'active', 'jump-a', 'naver']"
                      @click="goToUrl('https://m.map.naver.com/search2/search.nhn?query=' + row.name)">네이버로검색</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import moment from 'moment';
import Constants from '../constants';
import {
  RotateSquare3, Stretch, Circle8
} from 'vue-loading-spinner'

let map = null;
const default_zoom = 15;
let markerList = [];
export default {
  name: 'Map',
  data () {
    return {
      responseData: {},
      maskData: [],
      isLoading: false,
      cur_lat: 0,
      cur_lng: 0,
      circle: null,
      order: 0,
    }
  },
  components: {
    Circle8
  },
  watch:{
    $route () {
    },
  },
  mounted () {
    let mapOptions = {
      center: new naver.maps.LatLng(37.4979392, 127.0288518),
      zoom: default_zoom,
      minZoom: 11,
      maxZoom: 18
    };

    map = new naver.maps.Map('map', mapOptions);

    this.getGeoLocation();
  },
  methods: {
    getGeoLocation: function() {
      this.isLoading = true;
      let option = {
        enableHighAccuracy: true, //defaults to false
        timeout: Infinity, //defaults to Infinity
        maximumAge: 0
      };

      this.$getLocation(option).then(coordinates => {
        this.cur_lat = coordinates.lat;
        this.cur_lng = coordinates.lng;

        this.setLocationOfMap(this.cur_lat, this.cur_lng);

        // this.circle.setCenter(this.cur_lat, this.cur_lng);
        this.getMaskList(this.cur_lat, this.cur_lng);
        // console.log(coordinates);
      });
    },
    setLocationOfMap: function(lat, lng) {
      var target = new naver.maps.LatLng(lat, lng);
      map.setCenter(target);
      map.setZoom(default_zoom);
    },
    getCurrentLocationFromMap: function() {
      let point = map.getCenter();

      this.cur_lat = point._lat;
      this.cur_lng = point._lng;
    },
    findMaskFromCurrentMap: function() {
      this.getCurrentLocationFromMap();
      this.getMaskList(this.cur_lat, this.cur_lng);
    },
    getMaskList: function(lat, lng) {
      this.isLoading = true;
      axios
        .get(Constants.ENDPOINT + '?lat=' + lat + '&lng=' + lng + "&m=1000")
        .then(response => {
          // console.log(response.data);
          this.responseData = response.data;
          this.maskData = this.responseData.stores;
          this.drawMarker(this.maskData);
          this.drawCircle();
          this.changeOrder(this.order);

          let _thisRef = this;
          setTimeout(function() {
            _thisRef.isLoading = false;
          }, 300);

        });
    },
    drawMarker: function(dataList) {
      markerList.forEach(function (marker) {
        marker.setMap(null);
      });
      var style = "";
      dataList.forEach(function(data, index) {
        if (data.remain_stat === 'plenty') {
          style =  'text-info';
        } else if (data.remain_stat === 'some') {
          style =  'text-success';
        } else if (data.remain_stat === 'few') {
          style =  'text-warning';
        } else if (data.remain_stat === 'empty') {
          style =  'text-muted';
        } else if (data.remain_stat === null) {
          style =  'text-muted';
        }

        var marker = new window.naver.maps.Marker({
          position: new window.naver.maps.LatLng(data.lat, data.lng),
          map: map,
          icon: {
            content: '<i class="material-icons ' + style + ' pin-icon-map" id="pin_' + index + '">location_on</i>',
            anchor: new naver.maps.Point(10, 20)
          },
          id: 'pin_' + index
        });
        markerList.push(marker);
      });
    },
    drawCircle: function() {
      if (this.circle != null) {
        this.circle.setMap(null);
      }
      var circle = new naver.maps.Circle({
        map: map,
        center: new naver.maps.LatLng(this.cur_lat, this.cur_lng),
        radius: 1000,
        fillColor: 'orange',
        fillOpacity: 0.2
      });
      this.circle = circle;
    },
    moveAndJumpPin: function(id) {
      this.drawMarker(this.maskData);
      let data = this.maskData[id];
      this.setLocationOfMap(data.lat, data.lng);
      // console.log(markerList[id]);
      markerList.forEach(function(marker) {
        // console.log(marker);
        if (marker.id === 'pin_' + id) {
          marker.setAnimation(null);
          marker.setAnimation(naver.maps.Animation.BOUNCE);
        }
      });
      // scroll up
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // let selectedMarker = markerList[id];
      // console.log(selectedMarker);
      // selectedMarker.setAnimation(null);
      // selectedMarker.setAnimation(naver.maps.Animation.BOUNCE);
      // markerList[id].setAnimation(naver.maps.Animation.BOUNCE);
    },
    getTextString: function(amount) {
      if (amount === 'plenty') {
        return '많음(100+)';
      } else if (amount === 'some') {
        return '보통(30~99)';
      } else if (amount === 'few') {
        return '부족(2~29)';
      } else if (amount === 'empty') {
        return '없음(0~1)';
      } else if (amount === null) {
        return '정보없음';
      }
    },
    getTextStyle: function(amount) {
      console.log(amount);
      if (amount === 'plenty') {
        return 'text-info';
      } else if (amount === 'some') {
        return 'text-success';
      } else if (amount === 'few') {
        return 'text-warning';
      } else if (amount === 'empty') {
        return 'text-muted';
      } else if (amount === null) {
        return 'text-muted';
      }
    },
    getBadgeStyle: function(amount) {
      if (amount === 'plenty') {
        return 'badge-info';
      } else if (amount === 'some') {
        return 'badge-success';
      } else if (amount === 'few') {
        return 'badge-warning';
      } else if (amount === 'empty') {
        return 'badge-secondary';
      } else if (amount === null) {
        return 'badge-secondary';
      }
    },
    getButtonStyle: function(amount) {
      if (amount === 'plenty') {
        return 'btn-info';
      } else if (amount === 'some') {
        return 'btn-success';
      } else if (amount === 'few') {
        return 'btn-warning';
      } else if (amount === 'empty') {
        return 'btn-secondary';
      } else if (amount === null) {
        return 'btn-secondary';
      }
    },
    goToUrl: function(url) {
      window.location = url;
    },
    changeOrder: function(order) {

      this.order = order;
      this.isLoading = true;
      if (order === 0) {
        this.maskData.sort(function (a, b) {
          var aValue = 0;
          var bValue = 0;
          if (a.remain_stat === 'plenty') {
            aValue = 3;
          } else if (a.remain_stat === 'some') {
            aValue = 2;
          } else if (a.remain_stat === 'few') {
            aValue = 1;
          } else {
            aValue = 0;
          }

          if (b.remain_stat === 'plenty') {
            bValue = 3;
          } else if (b.remain_stat === 'some') {
            bValue = 2;
          } else if (b.remain_stat === 'few') {
            bValue = 1;
          } else {
            bValue = 0;
          }

          return bValue - aValue;
        });
      } else if (order === 1) {
        this.maskData.sort(function (a, b) {
          return new Date(b.stock_at) - new Date(a.stock_at);
        });
      }

      let _thisRef = this;
      setTimeout(function() {
        _thisRef.isLoading = false;
      }, 200);
    }
  }
}
</script>

<style scoped>
  .card-container {
    padding: 20px;
    margin: 10px 10px;
  }

  .store-name {
    font-size: 20px;
    font-weight: bold;
  }

  .store-address {
    margin-top: 3px;
    font-size: 12px;
  }

  .store-date {
    font-size: 12px;
  }

  .card-text {
    color: #464646;
  }

  .btn:focus, .btn:active {
    /*background-color: transparent;*/
    outline: none !important;
    box-shadow: none !important;
  }

  .spinner--circle-8 {
    margin: 10% auto auto;
  }

  .btn-description {
    background-color: white;
    border-color: black;
  }

  .pin-icon {
    font-size: 15px;
  }

  .pin-icon-map {
    font-size: 30px;
  }

  .badge-text {
    font-size: 15px;
    margin-left: 5px;
  }

  .jump-a {
    height: 50%;
  }

  .btn-refresh span {
    vertical-align: middle;
  }

  .naver {
    background: white;
    border-color: #00CE6C;
    color: #00CE6C;
    font-weight: bold;
  }

  .badge {
    vertical-align:middle;
    margin-top: -5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Map.vue